import { encrypt, decrypt } from "@/utils/aes.js";
function fetchRequest(url, options,apikey) {
  // console.log(apikey,'apikeyapikey')
  const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apikey}`,
  }
  options.headers = {
      ...headers,
      ...options.headers,
  };
  return fetch(url, options);
}

export async function chatCompletions(stream ,messages,ajaxObj) {
  const data = localStorage.getItem("selectAIINFO")?JSON.parse(localStorage.getItem("selectAIINFO")):null;
  let wxToken = sessionStorage.getItem("token");
  if(!data){
    alert("模型配置不存在，请联系管理员！！！");
    return;
  }
  let reqObj = {
    apikey:"",
    apiurl:"",
    modelid:""
  }
  if(ajaxObj){
    reqObj.apikey = ajaxObj.apikey;
    reqObj.apiurl = ajaxObj.apiurl;
    reqObj.modelid = ajaxObj.modelid;
  }else{
    reqObj.apikey = data.apikey;
    reqObj.apiurl = data.apiurl;
    reqObj.modelid = data.default_modelid;
  }
  // console.log(reqObj.apikey,ajaxObj,'chatCompletions')
  const apikey = decrypt(wxToken,reqObj.apikey);
  return fetchRequest(reqObj.apiurl, {
    method: "POST",
    body: JSON.stringify({
      model: reqObj.modelid,
      messages: messages,
      stream: true,
      stream_options: {
        include_usage: true,
      },
    }),
    signal: stream
  },apikey);
}